"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.widgetsDataTableWidget_de_de = void 0;
function widgetsDataTableWidget_de_de() {
    return {
        "widgets.datatable.errors.notconfiguredyet": "Bitte konfigurieren Sie das Daten-Tabelle Widget!"
    };
}
exports.widgetsDataTableWidget_de_de = widgetsDataTableWidget_de_de;
